<template>
  <div class="nav scrollbar">
    <div v-if="userInfo" class="portrait" @click="showUserCenter">
      <div class="avatar pointer">
        <div
          class="id"
          v-if="userInfo.role_id && userInfo.role_id !== 40001"
        >{{ $store.getters.roleName }}</div>
        <div class="avatar" style="overflow:hidden">
          <img :src="userInfo.avatar_url" style="width:100%;height:100%">
        </div>
      </div>
      <p class="name">{{userInfo.real_name}}</p>
      <p class="school" v-if="userInfo.role_id !== 40001">{{userInfo.unit_name}}</p>
      <p class="phone" v-if="userInfo.mail">{{userInfo.mail}}</p>
      <p class="phone" v-else style="color:red">{{$t('unbind')}}</p>
    </div>
    <div class="menu">
      <div
        class="menu-item vertical"
        :class="{'active': active === item.path}"
        v-for="(item,index) in menu"
        :key="index"
        v-if="item.path !== 'offlineTool'"
        @click="selectRoute(item.path)"
      >
        <div class="icon" :style="{'background-position':item.position}"></div>
        <span class="label">{{$ct(item.i18n)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['iPath'],
  data() {
    return {
      active: ''
    }
  },
  computed: {
    menu() {
      return this.$store.state.user.menu
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    selectRoute(path) {
      if (path === this.$route.name) {
        this.$router.push(this.iPath({
          name: path,
          query: {
            t: +new Date()
          }
        }))
      } else {
        this.$router.push(this.iPath({
          name: path
        }))
      }
    },
    showUserCenter() {
      this.$store.commit('USERCENTERSHOW', true)
    }
  },
  mounted() {
    this.$store.dispatch('getMenu')
    this.active = this.$route.name
  },
  watch: {
    '$route'(to) {
      this.active = to.name
    }
  }

}
</script>

<style lang="scss" scoped>
.nav {
  width: 200px;
  background-color: #ffffff;
  overflow: auto;
  box-shadow: 4px 0 16px 0 rgba(0, 196, 170, 0.1);
  position: relative;
}
.menu {
  height: calc(100% -250px);
  background-color: #ffffff;
  cursor: pointer;
}

.menu-item {
  padding: 15px 0px 15px 30px;
  display: flex;
  color: #2d2f33;
  &:hover {
    background-color: #ebf8f2;
  }
}
i {
  color: #475669;
}
.label {
  font-size: 16px;
  margin-left: 30px;
  color: #475669;
}
.active {
  background-color: #ebf8f2;
}
.portrait {
  width: 100%;
  padding: 40px 0;
  cursor: pointer;
  background: #fff;
  position: inherit;
  &:hover {
    background: #fff;
    opacity: 0.3;
  }
}

p {
  text-align: center;
  line-height: 30px;
}
.school {
  font-size: 12px;
}
.phone {
  font-size: 12px;
}
.tab {
  cursor: pointer;
  padding: 0 5px;
}
.id {
  width: 80px;
  height: 26px;
  border-radius: 4px;
  background: #fd8200;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px #fd8200;
  border: 2px #fff solid;
  font-size: 12px;
}
.avatar {
  width: 80px;
  height: 80px;
  // overflow: hidden;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  border: #ccc 1px solid;
  // overflow: hidden;
  &:hover {
    opacity: 0.9;
  }
}
.icon {
  width: 26px;
  height: 26px;
  background-image: url('~@/common/assets/back.svg');
  background-repeat: no-repeat;
}
.auth_code {
  width: 149px;
  height: 40px;
  text-align: center;
  background-color: #ffbd00;
  color: #fff;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  margin-left: 8px;
  position: absolute;
}
.unAnth_code {
  width: 149px;
  height: 40px;
  text-align: center;
  background-color: #d8d8d8;
  color: #666666;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  margin-left: 8px;
  position: absolute;
}
.auth_code:hover {
  background-color: #ffd14f;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  background-color: #d8d8d8 !important;
}
.pointer {
  margin-bottom: 15px;
}
</style>
